import React from 'react'

import InfoDescription from '../../components/Info/Description'
import { sections } from '../../constants/programmes'
import Image from './Image'

const Description = () => {
  return (
    <InfoDescription
      title="O’ Levels Computing"
      image={<Image />}
      alt="A woman holding a magnifying glass on top of a stack of documents."
      id={sections.description}
    >
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Convallis
      volutpat mattis nisi tortor, mus. Hendrerit nulla ac consectetur et etiam
      tempor fames blandit netus. Molestie nulla semper magna nec. Risus,
      aliquam ridiculus potenti in vel sollicitudin nisi diam egestas/blandit
      netus. Molestie nulla semper magna nec. Risus, aliquam ridiculus potenti
      in vel sollicitudin nisi diam egestas/
    </InfoDescription>
  )
}

export default Description
